<template>
  <v-container fluid grid-list-lg>
    <v-card :loading="loading" outlined>
      <ListTitle :showBackButton="false" :access="false" :title="`${Customer.length} Customer`">

      </ListTitle>

      <v-card-title>
        <v-layout row wrap>
          <v-flex xs12 sm4>
            <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search" single-line
              hide-details clearable></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-data-table class="pageHeight" :headers="headers" :items="Customer" :search="search" :loading="loading"
        :sort-by="sortBy" :page.sync="page" hide-default-footer :items-per-page="itemsPerPage">
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-center" @click="viewProfile(item)">{{ item.id }}</td>
            <td class="text-left" @click="viewProfile(item)">
              <span class="text-capitalize">{{ item.name }}</span>


            </td>
            <td class="text-center" @click="viewProfile(item)">
              {{ item.studentCount }}
            </td>
            <td class="text-right" @click="viewProfile(item)">
              {{ item.balance | currency }}


            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import customerService from "@/modules/Customer/service.js";

export default {
  name: "no-subscription-list",
  data() {
    return {
      loading: false,
      Customer: [],
      search: null,
      page: 1,
      sortBy: "id",
      pageCount: 0,
      sortDesc: false,
      itemsPerPage: 10,
      headers: [
        {
          text: "ID",
          value: "id",
          sortable: true,
          align: "center",
        },
        {
          text: "Name",
          value: "name",
          sortable: true,
          align: "left",
        },
        {
          text: "Student Count",
          value: "studentCount",
          sortable: true,
          align: "center",
        },
        {
          text: "Balance",
          value: "balance",
          sortable: true,
          align: "right",
        },
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    viewProfile(val) {
      this.$router.push({ path: `/parents/${val.id}/profile` });
    },
    getList() {
      this.loading = true;
      return customerService.getAllNoSubscription().then((response) => {
        console.log('response', response)
        this.loading = false;
        this.Customer = response.data;
        this.itemsPerPage = this.Customer.length

      });
    },
  }
}
</script>

<style scoped></style>